// extracted by mini-css-extract-plugin
export var container = "sender_container__BbTnU";
export var names = "sender_names__pv3WK";